export class GsbModule {
   _entDefName?: string;
   id?: string;
   name?: string;
   title?: string;
   code?: string;
   description?: string;
   isActive?: boolean;
   isDeleted?: boolean;
   createDate?: Date;
   lastUpdateDate?: Date;
   createdBy_id?: string;
   lastUpdatedBy_id?: string;

   constructor(obj?: Partial<GsbModule>) {
       Object.assign(this, obj);
       this._entDefName = "GsbModule";
   }
} 